'use client';
import { useEffect } from 'react';
import { Product } from '../types/type';
import ProductCard from '@/features/product-card/components/productCard';
import NumberedPagination from '@/features/pagination/NumberedPagination';
import { pushToDataLayer, toGa4Item } from '@/features/gtm/gtmUtils';

const ShopProducts = ({
  products,
  itemListId = 'shop',
  itemListName = 'Shop',
  itemCategory,
}: {
  products: any;
  itemListId?: string;
  itemListName?: string;
  itemCategory?: string;
}) => {
  useEffect(() => {
    if (!products?.data?.length) return;

    const page = Number(products?.meta?.current_page) || 1;
    const perPage = Number(products?.meta?.per_page) || products.data.length;
    pushToDataLayer('view_item_list', {
      ecommerce: {
        item_list_id: itemListId,
        item_list_name: itemListName,
        items: products.data.map((product: Product, index: number) =>
          toGa4Item(product, (page - 1) * perPage + index + 1, itemCategory)
        ),
      },
    });
  }, [products, itemListId, itemListName, itemCategory]);

  const page = Number(products?.meta?.current_page) || 1;
  const perPage = Number(products?.meta?.per_page) || products?.data?.length || 0;

  return (
    <div>
      <div className="row row-cols-xl-4  row-cols-md-3 row-cols-2 row-cols-1 justify-content-center g-3">
        {products?.data?.length > 0 ? (
          products?.data?.map((product: Product, i: number) => (
            <ProductCard
              key={i}
              data={product}
              itemListId={itemListId}
              itemListName={itemListName}
              itemCategory={itemCategory}
              itemIndex={(page - 1) * perPage + i + 1}
            />
          ))
        ) : (
          <div className="error w-50 0 w-md-100  padding-top padding-bottom sec-bg-color2">
            <div className="container">
              <div className="error__wrapper">
                <div
                  className="error__inner"
                  data-aos="fade-up"
                  data-aos-duration={1000}
                >
                  {/* <div className="error__thumb text-center">
                    <img src="/images/others/error.png" alt="404 image" />
                  </div> */}
                  <div className="error__content text-center">
                    <h2 className="fw-medium">No product found</h2>
                    <p className="mb-3">
                      Try adjusting your search or filter criteria
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {products?.meta?.last_page > 1 && (
        <div className="product-btn text-center mt-5">
          {/* <Link href="#" className="about__btn trk-btn trk-btn--primary">
            View More
          </Link> */}
          <NumberedPagination meta={products?.meta || {}} />
        </div>
      )}
    </div>
  );
};

export default ShopProducts;
